import React, { useEffect, useState } from 'react'
import { Box, Grid, Typography, Card, CardContent } from '@material-ui/core'
import DateRangeSelector from '../../modalities-machine-logs/components/DateRangeSelector'
import GaugeChart from './GaugeChart'
import LineChart from './LineChart'
import * as api from '../../data'

const metricList = [
  { key: 'heliumLevel', label: 'Helium Level' },
  { key: 'heliumPressure', label: 'Helium Pressure' },
  { key: 'roomTemp', label: 'Room Temp' },
  { key: 'roomHumidity', label: 'Room Humidity' },
  { key: 'waterFlow', label: 'Water Flow' },
  { key: 'waterTemp', label: 'Water Temp' },
]

const MetricsDashboard = ({ modalityId }) => {
  const [dashboardData, setDashboardData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [dateRange, setDateRange] = useState({ startDate: '-7d', endDate: null })

  const fetchDashboard = async () => {
    try {
      setLoading(true)
      const res = await api.modalities.fetchDashboardMetrics(modalityId, dateRange)
      setDashboardData(res)
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchDashboard()
  }, [modalityId, dateRange])

  const handleTimeframeChange = (start, end) => {
    setDateRange({ startDate: start, endDate: end })
  }

  return (
    <Box p={2}>
      <Box mb={3}>
        <DateRangeSelector onChange={handleTimeframeChange} />
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant='h6'>Gauges</Typography>
        </Grid>
        {metricList.map((metric) => (
          <Grid item xs={12} sm={6} md={6} key={metric.key}>
            <Card>
              <CardContent>
                <GaugeChart label={metric.label} data={dashboardData?.graphs?.[metric.key]} loading={loading} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box mt={4} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant='h6'>Trends</Typography>
        </Grid>
        {metricList.map((metric) => (
          <Grid item xs={12} sm={6} md={6} key={metric.key}>
            <Card>
              <CardContent>
                <LineChart
                  label={metric.label}
                  data={dashboardData?.graphs?.[metric.key]?.values}
                  unit={dashboardData?.graphs?.[metric.key]?.unit}
                  loading={loading}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default MetricsDashboard
